import { LIB_UI_POST_PIN_SUCCESS } from 'actions/pin/postPin.action';
import { reducePinPass } from 'reducers/access/reducePinPass.fold';
import { nowAsIso } from 'utils/date/now.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

const deFault = () => ({
  lockToken: '',
  lastUpdate: nowAsIso(),
  permIds: [],
  perms: [],
});

const MAP = Object.freeze({
  [LIB_UI_POST_PIN_SUCCESS]: reducePinPass,
});

const accessReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? deFault(), action ?? {});

export default accessReducer;
